<div class="wrappers flex flex-row justify-start items-center full-grow-no-shrink-no-basis" style="gap:10px"
     title="{{item.cells[fieldDefinition.key] && item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : ''}}"
>
    <a
            (click)="onClick($event)"
            class="flex flex-row justify-start items-center" particleAnalytics
            analyticsCategory="link-cell-viewer"
            [ngClass]="(item.cells[fieldDefinition.key]?.metaData?.LinkText === 'true') || ((!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true') && !disabled) ? 'link-color' : 'disabled'"
            [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
    >
        <div class="flex flex-row justify-between items-center full-grow-no-shrink-no-basis ">
            <div
                    class="ellipsis full-grow-no-shrink-no-basis "
                    attr.data-cy="{{item.cells[fieldDefinition.key]?.displayText}}"
                    title="{{item.cells[fieldDefinition.key]?.displayText}}"
            >{{item.cells[fieldDefinition.key]?.displayText}}</div>
        </div>
    </a>
  <app-gtc-scenario-tags
    [tags]="tags"
    [tagClassMap]="tagClassMap"
    [templateUpdateChoices]="templateUpdateChoices"
    [isTemplateUpdateAvailable]="isTemplateUpdateAvailable"
    [isCountryTrackerUpdateAvailable]="isCountryTrackerUpdateAvailable"
    [isLegacyTemplate]="isLegacyTemplate"
    [data]="item"
    [isLocked]="isLocked"
    [versionTooltips]="versionTooltips"
    [lockedScenarioMessage]="lockedScenarioMessage"
    (tagClick)="onTagClick($event.event, $event.tag)"
  ></app-gtc-scenario-tags>
</div>
